<template>
  <div id="wrapper">
    <SidebarView :users="true" :permissions="true" :user-visible="true" />
    <div class="d-flex flex-column" id="content-wrapper">
      <div id="content">
        <TopbarView />
        <b-container>
          <div class="">
            <div class="row">
              <div class="col-12 col-md-8">
                <div class="card card-shape home-box">
                  <div class="card-header py-3 d-flex flex-row align-items-center">
                    <h6 class="m-0 fw-bold text-green">Users Roles</h6>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-9">
                        <multiselect v-model="form.selected_role" name="selected_role" placeholder="Select A User Role"
                          label="display_name" track-by="id" :options="roles" @select="roleSelected"></multiselect>
                      </div>
                      <div class="col-3">
                        <roles-modal @saveRole="saveRole" @editRole="editRole" :selected_role="form.selected_role"
                          :disable_edit="disable_edit" :products_options="products_options" :coa_options="coa_options"></roles-modal>
                        <!--Roles Modal End-->
                        <!-- <a class="btn btn-success">Add Role</a> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 mt-2">
                <div class="card card-shape home-box">
                  <div class="card-header py-3 d-flex flex-row align-items-center">
                    <h6 class="m-0 fw-bold text-green">Permissions</h6>
                  </div>
                  <div class="card-body">
                    <user-permissions-table
                      :isLoading="isLoading"
                      :form="form"
                      :errors="errors"
                      :permissions="permissions"
                      :selectedPermissionIds="selectedPermissionIds"
                      :is_Updating="is_Updating"
                      @togglePermission="togglePermission"
                      @selectModule="selectModule"
                      @updatePermissionsNow="updatePermissionsNow"
                    ></user-permissions-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-container>
      </div>
      <Footer></Footer>
    </div>

    <!-- AI -->
		 <ChatBot />
		<!-- End AI -->
    <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
  </div>
</template>


<script>
import Multiselect from "vue-multiselect";
import BeatLoaderComponent from "@/views/components/Loader/BeatLoaderComponent.vue";
// import { Form } from "vform";
import UserPermissionsTable from "./tables/UserPermissionsTable.vue";
import ApiService from "@/core/services/api.service";

import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import RolesModal from "./forms/RolesModalForm.vue";
import ChatBot from "@/views/components/AI/ChatBot.vue";
// Backend now returns module nodes with child permissions already grouped.

export default {
  mounted() {
    this.getUserOptions();
    this.getCOAProduct();
  },
  components: {
    Multiselect,
    UserPermissionsTable,
    SidebarView,
    TopbarView,
    Footer,
    RolesModal,
    BeatLoaderComponent,
    ChatBot,
  },
  data() {
    return {
      form: {
        id: "",
        selected_role: "",
        display_name: "",
        nameState: null,
      },
      disable_edit: "",
      errors: [],
      isLoading: true,
      roles: [],
      permissions: [],
      selectedPermissionIds: [],
      is_Updating: false,
      products_options: [],
      coa_options: [],
    };
  },
  methods: {
    togglePermission({ id, checked }) {
      const pid = Number(id);
      if (!Number.isFinite(pid)) return;
      const exists = this.selectedPermissionIds.includes(pid);
      if (checked && !exists) this.selectedPermissionIds.push(pid);
      if (!checked && exists) {
        this.selectedPermissionIds.splice(this.selectedPermissionIds.indexOf(pid), 1);
      }
    },
    selectModule({ ids, checked }) {
      const moduleIds = (Array.isArray(ids) ? ids : [])
        .map((x) => Number(x))
        .filter((x) => Number.isFinite(x));
      if (moduleIds.length === 0) return;

      if (checked) {
        moduleIds.forEach((pid) => {
          if (!this.selectedPermissionIds.includes(pid)) this.selectedPermissionIds.push(pid);
        });
        return;
      }

      this.selectedPermissionIds = this.selectedPermissionIds.filter(
        (pid) => !moduleIds.includes(pid)
      );
    },
    async getUserOptions() {
      this.$Progress.start();
      this.isLoading = true;

      await ApiService.get("/roles/dropdown")
        .then((response) => {
          // console.log(response.data);
          this.roles = response.data.roles;
          // this.form.selected_role = this.roles[0];
          this.isLoading = false;
          // if (this.roles != null) {
          //   this.roleSelected(this.form.selected_role);
          // }

          this.$Progress.finish();
        })
        .catch((error) => { });
    },

    async getCOAProduct() {
      this.$Progress.start();
      this.isLoading = true;

      await ApiService.get("/roles/product-coa")
        .then((response) => {
          console.log(response.data);
          this.products_options = response.data.products;
            this.coa_options = response.data.coa;
              // this.roles = response.data.roles;
              // this.form.selected_role = this.roles[0];
              this.isLoading = false;
          // if (this.roles != null) {
          //   this.roleSelected(this.form.selected_role);
          // }

          this.$Progress.finish();
        })
        .catch((error) => { });
    },

    // initialState() {
    //   return {
    //     form: {
    //       display_name: "",
    //       nameState: "",
    //     },
    //     isLoading: false,
    //     isSaving: false,
    //   };
    // },
    async roleSelected(role) {
      this.isLoading = true;
      // console.log(role)
      if (role != undefined) {
        await ApiService.get("/users/permissions/getPermissions/" + role.id)
          .then((response) => {
            // Backend (fixed): returns module nodes array with permissions[] children + role_permissions (IDs)
            const raw = response?.data || {};
            const body = raw?.data && typeof raw.data === "object" ? raw.data : raw;

            const modules = Array.isArray(body?.permissions) ? body.permissions : [];
            const role_permissions = Array.isArray(raw?.role_permissions || body?.role_permissions)
              ? (raw?.role_permissions || body?.role_permissions)
              : [];

            // Never show empty parent modules.
            this.permissions = modules
              .map((m) => ({
                ...m,
                permissions: Array.isArray(m?.permissions) ? m.permissions : [],
              }))
              .filter((m) => m.permissions.length > 0);

            // Single source of truth: selected permission IDs (numbers).
            this.selectedPermissionIds = role_permissions.slice();
            // console.log(this.form.selected_role);
            if (this.form?.selected_role != undefined) {
              this.disable_edit = false
            } else {
              this.disable_edit = true
            }
            // console.log(this.disable_edit);

            this.isLoading = false;
            this.$Progress.finish();
          })
          .catch((error) => {
            this.isLoading = false;
          });
      }

    },
    async saveRole(form) {
      this.isLoading = true;
      this.isSaving = true;
      this.$Progress.start();
      await ApiService.post("roles/store", form)
        .then((response) => {

          this.$bvModal.hide("roles-modal");
          this.$Progress.finish();
          this.isSaving = false;
          //   this.form = this.initialState().form;
          this.getUserOptions();
          this.isLoading = false;
          toast.fire({
            icon: "success",
            title: response.data.message,
          });
          // this.resetForm();
          this.errors = [];
        })
        .catch((error) => {
          this.isSaving = false;
          this.$Progress.fail();
          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          }
        });

    },
    async editRole(form) {
      this.isLoading = true;
      this.isSaving = true;
      this.$Progress.start();
      console.log(form);
      await ApiService.put("roles/update/" + form.id, form)
        .then((response) => {

          this.$bvModal.hide("roles-modal");
          this.$Progress.finish();
          this.isSaving = false;
          //   this.form = this.initialState().form;
          this.getUserOptions();
          this.isLoading = false;
          toast.fire({
            icon: "success",
            title: response.data.message,
          });
          // this.resetForm();
          this.errors = [];
        })
        .catch((error) => {
          this.isSaving = false;
          this.$Progress.fail();
          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          }
        });

    },
    async updatePermissionsNow() {
      this.is_Updating = true;
      this.$Progress.start();

      //submit the permissions to update them
      await ApiService.post(
        "/users/permissions/updatePermissions/" + this.form.selected_role.id,
        {
          permissions_checked: this.selectedPermissionIds,
        }
      )
        .then((response) => {
          // console.log(response.data);
          this.$Progress.finish();
          this.is_Updating = false;
          toast.fire({
            icon: "success",
            title: response.data.message,
          });
        })
        .catch((error) => {
          this.is_Updating = false;
        });
    },
  },
};
</script>
